'use es6';

import Template from '../models/Template';
import { RECEIVED_TEMPLATE, REQUESTED_TEMPLATE_FAILED, REQUESTED_TEMPLATE } from '../actions/ActionTypes';
import { RequestStatus } from '../constants/base';
export default ((state = new Template(), action) => {
  switch (action.type) {
    case REQUESTED_TEMPLATE:
      return state.set('status', RequestStatus.PENDING);

    case RECEIVED_TEMPLATE:
      return action.payload.template;

    case REQUESTED_TEMPLATE_FAILED:
      return state.set('status', RequestStatus.FAILED);

    default:
      return state;
  }
});